module.exports = __webpack_public_path__ + "img/3.0b300d69.jpg";